/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import {
  Flex,
  Button,
  FormControl,
  Checkbox,
  FormLabel,
} from "@chakra-ui/react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { MdDeleteSweep } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { DENOMINATIONS_DEFAULT } from "../constants";
import ReactHookFormDropdown from "../../../components/forms/react-hook-dropdown";
import { useLookupCurrencyMultiples } from "../../../services/lookups-mutations";
import FormInput from "../../../components/forms/form-Input";

export default function Denominations({
  currencies,
  addData,
  onNextStep,
  onPrevStep,
  denominations,
  disabled,
  followStandardDenominations,
  toggleStandardDenominations,
  isValid,
}) {
  const [currentEditing, setCurrentEditing] = useState(null);
  const {
    mutate: getMultiples,
    data: multipleList,
    // isPending: gettingMultiples,
    // error: multipleError,
    reset: cassetteMultipleReset,
  } = useLookupCurrencyMultiples();
  const {
    handleSubmit,
    getValues,
    watch,
    control,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      ...DENOMINATIONS_DEFAULT,
      denominations: [...denominations],
    },
  });
  const generalFieldProps = { control, errors };

  const formValidationRules = {
    currency: { required: "Please select currency" },
    multiple: { required: "Please select multiple" },
    shape: { required: "Please select shape" },
  };

  const { fields: denominationsFields, remove: denominationsFieldsRemove } =
    useFieldArray({
      control: generalFieldProps.control,
      name: "denominations",
    });

  const _denominations = watch("denominations");
  useEffect(() => {
    if (addData) {
      addData([...denominationsFields]);
    }
  }, [_denominations]);
  useEffect(() => {
    cassetteMultipleReset();
    const _currency = watch("currency");
    if (_currency) {
      getMultiples(_currency);
    }
  }, [watch("currency")]);
  const onCurrencyChange = () => {
    setValue("multiple", "");
  };
  const submitInfo = (data) => {
    const _denominations = [...denominationsFields];
    const newDenomination = {
      currency: data.currency,
      multiple: data.multiple,
      shape: data.shape,
      version: data.version,
    };
    if (currentEditing !== null) {
      _denominations[currentEditing] = newDenomination;
      setCurrentEditing(null);
    } else {
      _denominations.push(newDenomination);
    }
    reset({
      ...DENOMINATIONS_DEFAULT,
      denominations: [..._denominations],
    });
  };

  const editCell = ({ dataItem, dataIndex }) => {
    return (
      <td>
        <Flex
          title="Edit Denomination"
          cursor="pointer"
          onClick={() => {
            reset({
              ...getValues(),
              ...dataItem,
              denominations: [...denominationsFields],
            });
            setCurrentEditing(dataIndex);
          }}
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  const deleteCell = ({ dataIndex }) => {
    return (
      <td>
        <Flex
          title="Delete Denomination"
          cursor="pointer"
          onClick={() => {
            denominationsFieldsRemove(dataIndex);
          }}
        >
          <MdDeleteSweep fontSize="18px" color="red" />
        </Flex>
      </td>
    );
  };
  const cancelEditing = () => {
    reset({
      ...DENOMINATIONS_DEFAULT,
      denominations: [...denominationsFields],
    });
    setCurrentEditing(null);
  };
  return (
    <form onSubmit={handleSubmit(submitInfo)}>
      <Flex w="100%" justify="space-between" flexDirection="row">
        <Flex direction="column">
          <FormControl>
            <Checkbox
              isChecked={followStandardDenominations}
              onChange={() => {
                if (!followStandardDenominations) {
                  reset({ ...DENOMINATIONS_DEFAULT, denominations: [] });
                }
                toggleStandardDenominations();
              }}
            >
              <FormLabel style={{ margin: 0, whiteSpace: "nowrap" }}>
                Follow Standard Denomination For Customers
              </FormLabel>
            </Checkbox>
          </FormControl>
          {disabled ? (
            <p
              className="error-message"
              style={{ width: "100%", color: "black", whiteSpace: "nowrap" }}
            >
              Can Not Edit When Following Standard Denominations
            </p>
          ) : (
            <></>
          )}
        </Flex>
        <Flex w="100%" justify="flex-end" flexDirection="row">
          <Flex w="100%" justify="flex-end" flexDirection="row" gap="16px">
            <Button
              type="button"
              onClick={() => onPrevStep(denominationsFields)}
            >
              Back
            </Button>
            <Button
              type="submit"
              onClick={() => onNextStep(denominationsFields)}
            >
              Next
            </Button>
          </Flex>
        </Flex>
      </Flex>
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Currency"
        name="currency"
        id="shortName"
        text="name"
        data={
          currencies.map((currency) => ({
            value: currency.shortName,
            label: currency.name,
          })) || []
        }
        placeholder="Select Currency"
        rules={formValidationRules.currency}
        onChange={onCurrencyChange}
        dropdownProps={{ filterable: true }}
        disabled={disabled}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Multiple"
        name="multiple"
        data={
          multipleList?.data.map((elm) => ({
            value: elm.multiple.toString(),
            label: elm.multiple.toString(),
          })) || []
        }
        placeholder="Select Multiple"
        rules={formValidationRules.multiple}
        // dropdownProps={{ filterable: true }}
        disabled={disabled || !watch("currency")}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Shape"
        name="shape"
        id="id"
        text="text"
        data={[
          {
            value: "Notes",
            label: "Notes",
          },
          { value: "Coins", label: "Coins" },
        ]}
        placeholder="Select Shape"
        rules={formValidationRules.shape}
        dropdownProps={{ filterable: false }}
        disabled={disabled}
      />
      <FormInput
        {...generalFieldProps}
        label="Version"
        name="version"
        disabled={disabled}
      />
      <div style={{ width: "100%" }} />
      <Grid data={denominationsFields} style={{ width: "100%" }}>
        <GridColumn title="Currency" field="currency" />
        <GridColumn title="Multiple" field="multiple" />
        <GridColumn title="Shape" field="shape" />
        <GridColumn title="Version" field="version" />
        <GridColumn title="Edit" cell={editCell} width={120} />
        <GridColumn title="Delete" cell={deleteCell} width={120} />
      </Grid>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          gap: "16px",
        }}
      >
        {currentEditing !== null ? (
          <Button onClick={cancelEditing} disabled={disabled}>
            Cancel
          </Button>
        ) : (
          <></>
        )}
        <Button type="submit" disabled={disabled}>
          {currentEditing !== null ? "Update Denomination" : "Add Denomination"}
        </Button>
      </div>
    </form>
  );
}
